import React from "react"
import {
  TableContainer,
  Grid,
  IconButton,
  LinearProgress
} from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import { useHistory } from 'react-router-dom'
import {
  Show,
  SimpleShowLayout,
  ReferenceManyField,
  useShowController
} from 'react-admin'
import { BASE_URL } from '../../../providers/dataProvider'
import PermissionsEditableTable from './PermissionsEditableTable'

const PermissionsContent = ({ record, goBack }) => {
  return (
    <React.Fragment>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
      >
        <IconButton
          onClick={() => goBack()}
        >
          <ArrowBackIcon />
        </IconButton>
      </Grid>

      <TableContainer>
        <ReferenceManyField
          record={record}
          basePath={BASE_URL}
          source="id"
          reference="auth/users_permissions"
          sort={{ field: 'id', order: 'DESC' }}
          perPage={100}
          target="userid"
        >
          <PermissionsEditableTable />
        </ReferenceManyField>
      </TableContainer>
    </React.Fragment>
  )
}

const PermissionsEdit = (props) => {
  const id = props.match.params.id
  const { goBack } = useHistory()

  const { record, loaded } = useShowController({
    basePath: BASE_URL,
    resource: 'auth/users',
    id
  })

  if (!record || !loaded) {
    return <LinearProgress />
  }

  return (
    <Show
      title={`Permisos ${record.firstname} ${record.lastname}`}
      basePath={BASE_URL}
      resource="auth/users"
      id={id}
    >
      <SimpleShowLayout>
        <PermissionsContent
          record={record}
          goBack={goBack}
        />
      </SimpleShowLayout>
    </Show>
  )
}

export default PermissionsEdit